import axios from 'axios';

const API_URL = process.env.REACT_APP_BASE_URL;
const apiClient = axios.create({
  baseURL: API_URL,
});
export const {
  get, post, put, delete: destroy,
} = apiClient;
